<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-form-stack" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-select
            [control]="form.controls['category']"
            [itemsSource]="categories"
            [helpText]="'RENTAL_OBJECT_TYPE_FORM.HELP_TEXT.CATEGORY_LABEL'"
          ></astral-select>
        </astral-layout-group>
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          @if (showNumberOfRooms()) {
            <astral-input type="number" [control]="form.controls['numberOfRooms']"></astral-input>
          }
          @if (showRH91()) {
            <astral-input [control]="form.controls['rH91']" [helpText]="'RENTAL_OBJECT_TYPE_FORM.HELP_TEXT.RH91'"></astral-input>
          }
          @if (showBVK91()) {
            <astral-input [control]="form.controls['pointsBvk91']" [helpText]="'RENTAL_OBJECT_TYPE_FORM.HELP_TEXT.BVK91'"></astral-input>
          }
        </astral-layout-group>
        @if (isObjectTypeParking()) {
          <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
            <astral-checkbox [control]="form.controls['isGarage']" [helpText]="'RENTAL_OBJECT_TYPE_FORM.HELP_TEXT.ISGARAGE_LABEL'"></astral-checkbox>
            <astral-checkbox [control]="form.controls['parkingHasElectricity']"></astral-checkbox>
            <astral-checkbox [control]="form.controls['parkingHasRoof']"></astral-checkbox>
          </astral-layout-group>
        }
      </section>
    </form>
  }
</section>
